import React from 'react';
import {
    Datagrid,
    List,
    TextField,
    EditButton,
    DeleteButton,
    ShowButton,
    ReferenceField,
} from 'react-admin';

const BundleMetaChangeHistory = (props: any) => {
    return (
        <List {...props}>
            <Datagrid>
                <TextField source='id'/>
                <ReferenceField label="User Bundle" source="userBundleMetaId" reference="UserBundleMeta">
                    <TextField source="id"/>
                </ReferenceField>
                <TextField source='plan'/> 
                <TextField source='genderPreference' />
                <TextField source='mealMapping' />
                <TextField source='createdBy' />
                <TextField source='createByType' />
                <TextField source='state' />
                <TextField source='bundlePrice' />
                <TextField source='quotedPrice' />
                <TextField source='totalLeaves' />
                <TextField source='totalPeople' />
                <TextField source='quotedDiscount' />
                <TextField source='quotedNetPrice' />
                <DeleteButton/>
                <EditButton/>
                <ShowButton/>
            </Datagrid>
        </List>
    );
};

export default BundleMetaChangeHistory;